var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"info-tool-tip"},[_c('base-tool-tip',{attrs:{"icon-path":'icon-info.svg'}},[_c('div',{staticClass:"info-text"},[_c('div',[_c('span',{staticClass:"text"},[_vm._v(_vm._s(_vm.text))]),_vm._v(" "),_c('span',{staticClass:"popup-text",on:{"click":_vm.openPopup}},[_vm._v(_vm._s(_vm.popupText))])])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-307f1536","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/base-components/onboarding/InfoToolTip.vue
// module id = null
// module chunks = 